var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import React from 'react';


const ListOfItems = ({ items }) => /*#__PURE__*/
_jsx("ul", { className: "flex flex-wrap gap-8 max-w-md list-disc list-inside" }, void 0,
items.length ?
items.map((item) =>
'username' in item ? /*#__PURE__*/
_jsx("li", {}, item._id, item.username) : /*#__PURE__*/

_jsx("li", {}, item._id, item.name)

) :
null
);


export { ListOfItems };